import { useEffect, useState } from "react";
import { searchUsers } from "../api/users";

// Debounced server-side user search. GET /users/search matches first/last name
// only, needs 2+ characters and returns _id, firstName, lastName, picture, role.
// The cancelled flag drops responses for a query the user has already typed past.
export default function useUserSearch(query, delay = 300) {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const q = query.trim();
    if (q.length < 2) {
      setResults([]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    const timer = setTimeout(async () => {
      try {
        const users = await searchUsers(q);
        if (!cancelled) setResults(users || []);
      } catch (err) {
        console.error("User search failed:", err);
        if (!cancelled) setResults([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }, delay);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [query, delay]);

  return { results, loading };
}
